import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.TeamOfExpertsView.heading',
    defaultMessage: 'Zespół ekspertów'
  },
  filterAll: {
    id: 'views.TeamOfExpertsView.filter.All',
    defaultMessage: 'Wszyscy'
  },
  filterTechnology: {
    id: 'views.TeamOfExpertsView.filter.Technology',
    defaultMessage: 'Technologia'
  },
  filterBusiness: {
    id: 'views.TeamOfExpertsView.filter.Business',
    defaultMessage: 'Biznes'
  },
  filterHR: {
    id: 'views.TeamOfExpertsView.filter.HR',
    defaultMessage: 'HR'
  }
});



// WEBPACK FOOTER //
// ./src/views/TeamOfExperts/TeamOfExpertsView.intl.js